<div class="container">
  <img src="assets/img/alcmeon-maintenance.png" class="logo" alt="maintenance" />
  <div class="title">{{ 'm/maintenance/title' | translate }}</div>
  <div class="subtitle">{{ 'm/maintenance/subtitle' | translate }}</div>
  <div class="donotreload">{{ 'm/maintenance/do-not-reload' | translate }}</div>
</div>
